module.exports = __webpack_public_path__ + "media/images/error-d0f61c37ba91be7cc8f82cb983741781.png";